var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#2D4A6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.567 38.0783L30.8596 21.9383C30.4346 21.3539 29.5647 21.3539 29.143 21.9383L17.4323 38.0783C17.4034 38.118 17.3862 38.1649 17.3824 38.2138C17.3786 38.2627 17.3884 38.3117 17.4108 38.3554C17.4331 38.3991 17.4671 38.4357 17.509 38.4612C17.5509 38.4867 17.599 38.5002 17.6481 38.5H20.1383C20.3077 38.5 20.467 38.417 20.5666 38.2809L29.9996 25.2785L39.4327 38.2809C39.5323 38.417 39.6916 38.5 39.861 38.5H42.3512C42.567 38.5 42.6932 38.2543 42.567 38.0783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.1095d9d26e67442e3b9664120c712965.svg";
export { ForwardRef as ReactComponent };